"use client"

import Heading from "../_components/Atoms/Heading"
import StoryText from "../_components/Atoms/Storytext"
import ButtonLink from "../_components/Molecules/ButtonLink"
import { useLangCode } from "@/src/utils/locale/useLangCode"
import { t } from "@/translations"
import { useEffect } from "react"

export default function NotFound() {
    const langCode = useLangCode()

    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = t(langCode, "error.not_found")
    }, [langCode])

    return (
        <main className="flex h-[80vh] flex-col items-center justify-center p-24 py-64">
            <Heading type="h1" className="mb-12">
                {t(langCode, "error.not_found")}
            </Heading>
            <StoryText size="size2" className="mb-24">
                {t(langCode, "error.not_found_description")}
            </StoryText>
            <ButtonLink
                href="/"
                prefetch={false}
                color="black"
                size="large"
                variant="primary"
            >
                {t(langCode, "error.return_home")}
            </ButtonLink>
        </main>
    )
}
